import moment from 'moment';
import * as mediaServer from 'Components/utils/media-server';

export function getBaiduStructuredPageData(title, description, imageUrls, pageUrl) {
  return {
    '@context': 'https://zhanzhang.baidu.com/contexts/cambrian.jsonld',
    '@id': pageUrl,
    title,
    description,
    images: imageUrls.map((url) =>
      mediaServer.getUrl({
        format: '_AUTOFORMAT_',
        url,
        width: 2000,
        height: 'auto',
        transform: 'resize',
        quality: 70,
      }),
    ),
    pubDate: moment()
      // Set to the beginning of the current quarter,
      // 1st day of months, 12:00 am
      .startOf('quarter')
      .format('YYYY-MM-DDThh:mm:ss'),
  };
}
